
const pt = {
    message: {
        title1: 'Controle remoto de casa inteligente, tecnologia, segurança e paz de espírito',
        content1: 'O AigoSmart ajuda você a gerenciar e controlar remotamente eletrodomésticos inteligentes, e os dispositivos também podem perceber e se conectar. O acionamento de um clique pode fazer com que vários eletrodomésticos entrem em seu estado predefinido, criando uma casa inteligente segura e sem preocupações para você vida. ',
        title2: "AigoSmart é uma nova submarca da Aigostar",
        content2: "Os produtos são vendidos atualmente para Espanha, Portugal, França, Itália, Holanda, Alemanha, Finlândia, Dinamarca, Polônia, Rússia, Grécia, Áustria, Suíça, República Tcheca, Hungria, Eslováquia e outros países e regiões europeus.",
        content3: "Os vários eletrodomésticos da AIGOSTAR para cozinha, lavanderia e engomadoria continuam ocupando",
        content4: "Dez principais vendas.",
        title3: "Brand Honor",
        content5: "Rápido. Abra. Inove. Persevere",
        loading: 'Carregando',
        submit: 'Enviar',
        contactUs: "Contate-nos",
        privacy: "Acordo de Privacidade",
        policy: "Política de serviço",
        download: "Download",

    },
   
}

export default pt;